export default {"src":"/_next/static/media/news-hirarechy-mob.1777da61.svg","height":335,"width":334,"blurWidth":0,"blurHeight":0};